import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { showToast } from "src/utils/toaster/showToast";
import { useParams } from "react-router-dom";
import { useUpdateUserRewardWalletMutation } from "src/services/RewardService";
import UpdateRetailerRewardWalletForm from "./UpdateRetailerRewardWalletForm";


export type RetailerTotalRewardValues = {
  otp: string;
  amountToBeUpdate:string ;
};

type Props = {
  onClose: () => void;
  walletAmountData:string ;
};

const UpdateRetailerRewardWalletFormWrapper = ({ onClose , walletAmountData }: Props) => {
    const [updateWallet] = useUpdateUserRewardWalletMutation();
    const [wantToDisabledFiled, setWantToDisabledFiled] = useState(false);


  const { retailerId } = useParams();

  // Form Initial Values
  const initialValues: RetailerTotalRewardValues = {
    otp: "",
    amountToBeUpdate:walletAmountData
  };

  // Validation Schema
  const validationSchema = object().shape({
    otp: string().required("Please enter otp"),
    amountToBeUpdate: string().required("Please enter amount To BeUpdate"),
  });

  // Handle Submit
  const handleSubmit = (
    values: RetailerTotalRewardValues,
    { setSubmitting, resetForm }: FormikHelpers<RetailerTotalRewardValues>
  ) => { 
 
    const formattedValues = {
        otp: values?.otp,
        amountToBeUpdate:values?.amountToBeUpdate ,
        userId: retailerId,
    }

    updateWallet(formattedValues).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          setWantToDisabledFiled(false)
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <UpdateRetailerRewardWalletForm
              setWantToDisabledFiled={setWantToDisabledFiled}
              wantToDisabledFiled={wantToDisabledFiled}
              formikProps={formikProps}
              onClose={onClose}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default UpdateRetailerRewardWalletFormWrapper;
